var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventNote = function SvgEventNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.016 14.016v1.969H6.985v-1.969zm4.968 4.968V8.015H5.015v10.969zm0-15.984C20.062 3 21 3.938 21 5.016v13.969c0 1.078-.938 2.016-2.016 2.016H5.015c-1.125 0-2.016-.938-2.016-2.016V5.016C2.999 3.938 3.89 3 5.015 3h.984V.984h2.016V3h7.969V.984H18V3zm-1.968 6.984V12H6.985V9.984z"
  })));
};
export default SvgEventNote;